'use strict';

const lazyLoad = require('../../../common/frontend/helpers/lazy-load');
const fetch = require('../../../common/frontend/helpers/fetch-decorator')(
  window.fetch
);
const {
  getRememberMeSelection,
  getNewsletterSelection,
} = require('./social-common');

const successHandler = googleUser => {
  const { id_token } = googleUser.getAuthResponse();
  const host = window.location.origin;
  const qs = window.location.search;
  const postUrl = `${host}/google_auth_callback${qs}`;
  const remember_me = getRememberMeSelection();
  const newsletter = getNewsletterSelection();
  const terms_of_service_version = document.querySelector(
    'input[name="terms_of_service_version"]'
  ).value;
  const privacy_policy_version = document.querySelector(
    'input[name="privacy_policy_version"]'
  ).value;

  const body = new URLSearchParams({
    id_token,
    newsletter,
    remember_me,
    terms_of_service_version,
    privacy_policy_version,
    accept_terms: true,
  }).toString();

  fetch(postUrl, {
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body,
  })
    .then(response => (response.ok ? response.json() : null))
    .then(({ redirectTo }) => {
      if (window.location !== window.parent.location) {
        window.top.location.reload();
      } else {
        window.location.href = encodeURI(redirectTo);
      }
    });
};

const failureHandler = error =>
  window.OptimizeSuite.TrackingHub.add('google-login', {
    error: JSON.stringify(error),
  });

const authInit = () => {
  const { socialConfig } = window.Groupon.Utils.getConfigFromDom();
  const client_id = socialConfig.google.clientId;
  const auth2 = window.gapi.auth2.init({
    client_id,
  });
  auth2.attachClickHandler(
    document.getElementById('google-button'),
    {},
    successHandler,
    failureHandler
  );
};

module.exports = () => {
  const { socialConfig } = window.Groupon.Utils.getConfigFromDom();
  if (socialConfig.google.enabled) {
    lazyLoad.js('https://apis.google.com/js/api:client.js').then(() => {
      const { gapi } = window; // -> Google API ;)
      gapi.load('auth2', authInit);
    });
  }
};
